document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll("details.accordion-details");
  const announcer = document.getElementById("sr-announce");

  // Helper function to check if accordion is a footer accordion
  function isFooterAccordion(accordion) {
    return accordion.classList.contains("footer-accordion-details") || 
           accordion.closest("footer") !== null;
  }

  // Helper function to check if we're on desktop
  function isDesktop() {
    if (FoxTheme && FoxTheme.config && FoxTheme.config.mqlTablet !== undefined) {
      return !FoxTheme.config.mqlTablet;
    }
    return !window.matchMedia('screen and (max-width: 1023px)').matches;
  }

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector("summary");
    if (!summary) return;
    
    const label = summary.innerText.trim();
    const isFooter = isFooterAccordion(accordion);

    // Initial state - don't set aria-expanded for footer accordions on desktop
    if (!(isFooter && isDesktop())) {
      summary.setAttribute("aria-expanded", accordion.open ? "true" : "false");
    } else {
      summary.removeAttribute("aria-expanded");
    }

    accordion.addEventListener("toggle", function () {
      const isOpen = accordion.open;

      // Remove open attribute when accordion is closed
      if (!isOpen) {
        accordion.removeAttribute("open");
      } else {
        accordion.setAttribute("open", "");
      }

      // Update aria-expanded - skip for footer accordions on desktop
      if (!(isFooter && isDesktop())) {
        summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
      } else {
        summary.removeAttribute("aria-expanded");
      }

      // Safari / VoiceOver live announcement fix
      if (announcer) {
        announcer.textContent = `${label} ${isOpen ? "expanded" : "collapsed"}`;
      }
      
      // Optional: Add aria-label for screen reader context
      if (!(isFooter && isDesktop())) {
        summary.setAttribute(
          "aria-label",
          `${label} ${isOpen ? "expanded" : "collapsed"}`
        );
      }
    });

    // Handle viewport changes for footer accordions
    if (isFooter) {
      document.addEventListener("matchTablet", function() {
        if (summary) {
          summary.setAttribute("aria-expanded", accordion.open ? "true" : "false");
        }
      });

      document.addEventListener("unmatchTablet", function() {
        if (summary) {
          summary.removeAttribute("aria-expanded");
        }
      });
    }
  });
});

